import { isAnyOf } from '@reduxjs/toolkit';

import {
  clearRemoteRequestIfTeamingEnded,
  reconcileCaptionSession,
} from '../helpers/captionSession';
import type { AppStartListening } from '../helpers/types';

import {
  resetTeaming,
  setTeamingStatus,
} from 'features/teaming/teaming-base/store';

// What happens when VI1/VI2 ownership changes: drop departed peer demand, then
// start if anyone still wants captions, otherwise stop.
// Covers VI1 remove VI2, VI2 leave, and VI1 leave/handoff to VI2.
// The clear is synchronous so reconcile and status reporting see it.
export const registerCaptionOwnershipListeners = (
  startListening: AppStartListening
) => {
  startListening({
    matcher: isAnyOf(setTeamingStatus, resetTeaming),
    effect: async (_action, api) => {
      clearRemoteRequestIfTeamingEnded(api);
      await reconcileCaptionSession(api, 'captions-owner-change');
    },
  });
};
